// Import Swiper core module.
import Swiper from 'swiper';

// Import Swiper modules.
// eslint-disable-next-line import/no-unresolved
import { Autoplay } from 'swiper/modules';

// Configure Swiper to use modules.
Swiper.use([Autoplay]);

// Assign Swiper to window so Alpine can call on Swiper.
window.Swiper = Swiper;

/**
 * Initializes the Swiper slider, ensures an even number of slides,
 * and dynamically adjusts the margin for a playful effect.
 */
export async function initSwipers() {
    const swiperContainer = document.querySelector('.site-gallery .swiper-wrapper');
    const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));

    // Check if the number of slides is odd
    if (slides.length % 2 !== 0) {
        // Clone the last slide
        const lastSlide = slides[slides.length - 1];
        const clonedSlide = lastSlide.cloneNode(true);

        // Determine a random position to insert the cloned slide
        // The position is within the original slides to avoid having duplicates at the beginning or end
        const randomIndex = Math.floor(Math.random() * (slides.length - 2)) + 1;

        // Insert the cloned slide into the slides array at the random position
        slides.splice(randomIndex, 0, clonedSlide);

        // Clear the container and re-append the slides in their new order
        swiperContainer.innerHTML = '';
        slides.forEach(slide => swiperContainer.appendChild(slide));

        console.log('Odd number of slides detected. The last slide has been cloned and inserted randomly.');
    }

    // Initialize Swiper with the updated slides array
    const gallerySwiper = new Swiper('.site-gallery .swiper', {
        autoplay: {
            delay: 750,
        },
        allowTouchMove: true,
        slidesPerView: 1.45,
        speed: 2500,
        spaceBetween: 40,
        loop: true,
        centeredSlides: true,
        freeMode: true,
        breakpoints: {
            // when window width is >= 1023px
            1023: {
                slidesPerView: 'auto',
            },
            // when window width is >= 672px
            672: {
                slidesPerView: 2,
            },
        },
        on: {
            // These events ensure the margins are set correctly at the right time
            init: function(swiper) {
                setMargins(swiper);
            },
            slideChangeTransitionEnd: function(swiper) {
                setMargins(swiper);
            },
            transitionStart: function(swiper) {
                setMargins(swiper);
            },
        },
    });

    /**
     * Sets the margins for the slides by adding a class.
     * This method is more robust than inline styling.
     * @param {object} swiper - The Swiper object.
     */
    function setMargins(swiper) {
        swiper.slides.forEach((slide) => {
            const originalIndex = slide.dataset.swiperSlideIndex;

            // Only apply styling when the originalIndex is available
            if (originalIndex !== undefined) {
                // Add the 'is-elevated' class to slides with an odd original index
                if (parseInt(originalIndex) % 2 !== 0) {
                    slide.classList.add('is-elevated');
                } else {
                    slide.classList.remove('is-elevated');
                }
            }
        });
    }
}